export default class NavigationUtils{
  /**
   * Opens an external URL
   *
   * @param url URL that should be opened
   * @param target (Optional) target where the URL should be opened. Default is '_blank'
   */
  public static openExternUrl(url: string, target: string = 'blank'): void{
    window.open(url, target);
  }
}
